import QRCode from 'qrcode'

const common = {
	getQueryString:(name)=>{
		var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
		var r = window.location.search.substr(1).match(reg);
		if (r != null) return unescape(r[2]);
		return null;
	},
	getQueryData:(url)=>{
		var urlAll = url;
		var tmp = urlAll.split("#")[0];
		tmp = tmp.split("?");
		if (tmp.length == 1) {
			return {};
		}
		var list = tmp[1].split("&");
		var data = {};
		for (let index = 0; index < list.length; index++) {
			var element = list[index];
			var arr = element.split('=');
			if (arr.length >= 2) {
			data[arr[0]] = element.substring(arr[0].length + 1);
			}
		}
		return data;
	},
	getUrlAddQuery:(url, data)=>{
		if(Object.values(data).length>0){
			url = url + "?";
			var isFrist = true;
			for (const key in data) {
				var value = data[key];
				if (value === '') {
					continue;
				}
				if (isFrist) {
					isFrist = false;
					url = url + key + "=" + value;
				} else {
					url = url + "&" + key + "=" + value;
				}
			}
			return url;
		}else{
			return url
		}
	},
	checkEquipment:(type)=>{
		var u = navigator.userAgent;
		if(type == 'h5'){
			if (u.indexOf("Android") < 0 && u.indexOf("Linux") < 0 && u.indexOf("iPhone") < 0 && u.indexOf("Windows Phone") < 0 && u.indexOf("Harmony") < 0) {
				//h5 跳 pc
				var data = common.getQueryData(location.href);
				var url = window.location.protocol + "//" + window.location.host + "/PC/";
				location.href = common.getUrlAddQuery(url, data);
			}
		}else{
			if (!(u.indexOf("Android") < 0 && u.indexOf("Linux") < 0 && u.indexOf("iPhone") < 0 && u.indexOf("Windows Phone") < 0 && u.indexOf("Harmony") < 0)) {
				if(location.href.includes('yuekelist')) {
					// PC课程商品详情页需要自动跳转到H5的课程商品详情页
					const [courseId, id] = window.location.hash.substring(12).split('/')
					location.href = `${window.location.origin}/#/zhibokecheng?setid=${courseId}&&goodsId=${id}`
					return
				}
				//PC 跳 h5
				var urlData = common.getQueryData(location.href);
				var baseUrl = window.location.protocol + "//" + window.location.host + "/";
				location.href = common.getUrlAddQuery(baseUrl, urlData);
			} else {
				// pc环境下电子合同需要跳转到预览页
				if(location.href.includes('contract-preview')) {
					location.href = location.href.replace('contract-preview', 'preview')
				}
			}
		}
	},

	/**
	 * 描述：创建二维码
	 * @param   : element {HTMLElement} 需要显示的dom , content {string} 二维码内容， options{object} 配置项
	**/
   createQrCode(element, content, options = {}) {
		const defaultOptions = {
			height: 148,
			wight: 200, 
			padding:0, 
			margin:0
		}
		QRCode.toCanvas(element, content, { ...defaultOptions, ...options })
	},
	isIPAD:/iPad/i.test(window.navigator.userAgent) || (window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1)
}

export default common